import type { DynamicClient } from '@dynamic-labs-sdk/client';
import { assertDefined } from '@dynamic-labs-sdk/client/core';
import { ZerodevBundlerProvider } from '@dynamic-labs/sdk-api-core';

import { ZERODEV_RPC_BASE_URL } from '../../constants';
import { getZerodevChainProviderForNetworkId } from '../getZerodevChainProviderForNetworkId';
import { getZerodevProviderFromSettings } from '../getZerodevProviderFromSettings';

type GetZerodevRpcParams = {
  bundlerProvider?: ZerodevBundlerProvider;
  networkId: string;
  rpcType: 'paymaster' | 'bundler';
};

export const getZerodevRpc = (
  { networkId, bundlerProvider, rpcType }: GetZerodevRpcParams,
  client: DynamicClient
) => {
  const zerodevProvider = getZerodevProviderFromSettings(client);

  if (zerodevProvider?.zerodevPaymasterRpcUrl) {
    return zerodevProvider.zerodevPaymasterRpcUrl;
  }

  const zerodevChainProvider = getZerodevChainProviderForNetworkId(
    { networkId },
    client
  );

  assertDefined(
    zerodevChainProvider,
    `No zerodev provider found for network id ${networkId}`
  );

  const paymasterProvider =
    bundlerProvider ??
    zerodevProvider.zerodevBundlerProvider ??
    ZerodevBundlerProvider.Pimlico;

  const paramName =
    rpcType === 'bundler' ? 'bundlerProvider' : 'paymasterProvider';

  return `${ZERODEV_RPC_BASE_URL}/${rpcType}/${zerodevChainProvider.clientId}?${paramName}=${paymasterProvider}`;
};
